import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { GameStatus } from '@sorare/core/src/__generated__/globalTypes';
import { LiveDot } from '@sorare/core/src/components/live/LiveDot';
import { glossary } from '@sorare/core/src/lib/glossary';

import { LiveGameQuarterStatus_NBAGame } from './__generated__/index.graphql';

type Props = {
  game: LiveGameQuarterStatus_NBAGame;
  withLiveDot?: boolean;
};

export const LiveGameQuarterStatus = ({ game, withLiveDot = true }: Props) => {
  const { status } = game;

  if (status === GameStatus.playing) {
    return (
      <>
        {withLiveDot && <LiveDot animate />}
        {game.isHalftime ? (
          <FormattedMessage id="Game.status.halftime" defaultMessage="Half" />
        ) : (
          <FormattedMessage
            {...glossary.ordinal}
            values={{ ordinal: game.quarter }}
          />
        )}
      </>
    );
  }
  return null;
};

LiveGameQuarterStatus.fragments = {
  NBAGame: gql`
    fragment LiveGameQuarterStatus_NBAGame on NBAGame {
      id
      status
      quarter
      isHalftime
    }
  ` as TypedDocumentNode<LiveGameQuarterStatus_NBAGame>,
};
